module.exports = __webpack_public_path__ + "static/media/galerija_2014 (10).ceaec8be.jpg";